import { getFormErrorMessage, isFormFieldInValid } from "@/modules/formik/formikUtils"
import { cn } from "@/modules/lib/utils"
import type {
  ExerciseFormikType,
  ExerciseInputKey,
} from "@/modules/sessions/sessionForm/blocks/exerciseBlock/exerciseFormikTypes"
import { HURichTextInput, type HURichTextInputRef } from "@/modules/ui/components/richText/huRichTextInput"
import { formatTextToRichText } from "@/modules/ui/components/richText/richTextUtils"
import type { SimpleFormik } from "@/typings/formik"
import { word } from "@modules/core/utils/i18n"
import { type RefObject } from "react"

export function ExerciseDescriptionInput({
  formik,
  richTextRef,
  className,
  ...props
}: {
  formik: SimpleFormik<ExerciseFormikType, ExerciseInputKey>
  richTextRef: RefObject<HURichTextInputRef | null>
} & React.ComponentProps<"div">) {
  return (
    <div className={cn("rounded-2xl bg-surface-foreground px-5 py-6", className)} {...props}>
      <HURichTextInput
        ref={richTextRef}
        value={formatTextToRichText(formik.values.description)}
        onChange={(value) => {
          void formik.setFieldValue("description", value)
        }}
        label={word("sessionForm.exercise.description.label")}
        isRequiredInput
        maxLength={65000}
        paragrapheFontStyle="BM"
        isInvalid={isFormFieldInValid("description", formik)}
        error={getFormErrorMessage("description", formik)}
        placeholder={word("program.planning.create.exercise.placeholder")}
      />
    </div>
  )
}
